export function getVVColor(name) {
  return getComputedStyle(document.documentElement)
    .getPropertyValue(`--vv-${name}`)
    ?.trim();
}

export function getCSSVar(name) {
  return getComputedStyle(document.documentElement)
    .getPropertyValue(`--vv-${name}`)
    ?.trim();
}

export function setCSSVar(name, value) {
  document.documentElement.style.setProperty(`--vv-${name}`, value);
}
